import React, {
  useMemo, useState,
} from 'react';
import Box from '@mui/material/Box';
import { Loader } from 'src/components/Loader';
import { useMarketplaces } from 'src/hooks/marketplace';
import { useParams } from 'react-router-dom';

import {
  UnitsDataProvider,
} from 'src/components/profileComponents/Marketplace/components/UnitsTiles/context/UnitsDataProvider';

import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import {
  UnitsContextWrapper,
} from 'src/components/profileComponents/Marketplace/components/UnitsTiles/components/UnitsContextWrapper';

export const UnitTiles: React.FC = () => {
  const { id }: { id: string } = useParams();
  const { getMarketplace } = useMarketplaces();
  const marketplace = getMarketplace(id);

  const [error, setError] = useState('');

  const data = useMemo(() => {
    if (!marketplace) return null;
    return {
      marketplace,
      complexPropertyOptions: marketplace.complexProperties.map((item) => ({ label: item.translates?.[marketplace.language] || item.systemName, value: item })),
      placementPropertyOptions: marketplace.placementProperties.map((item) => ({ label: item.translates?.[marketplace.language] || item.systemName, value: item })),
      unitsOrder: marketplace.frontConfiguration.module.placementTile.propertiesSortOrder,
      unitsCard: marketplace.frontConfiguration.module.placementTile.card,
    };
  }, [marketplace]);

  if (!marketplace) {
    return (
      <Box
        width="100%"
        height="100%"
        display="flex"
        alignItems="center"
        justifyContent="center"
        mb={4}
      >
        <Loader />
      </Box>
    );
  }

  return (
    <Box py={5} px={4}>
      {data && (
      <UnitsDataProvider data={data}>
        <UnitsContextWrapper marketplace={marketplace} setError={setError} />
      </UnitsDataProvider>
      )}
      <Snackbar open={!!error} autoHideDuration={6000} onClose={() => setError('')}>
        <Alert onClose={() => setError('')} elevation={6} variant="filled" severity="error">
          { error }
        </Alert>
      </Snackbar>
    </Box>
  );
};
